import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { virtualizedMenuRenderer } from 'foundations-components/transitional/utils/virtualizedMenuRenderer';
import { useSearchParams } from '../../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SelectFilter({
  filter,
  multi = false,
  virtualized = false
}) {
  const params = useSearchParams();

  // this may be the case if the filter does not apply to the current app context
  if (!filter) return null;
  const id = `eco_${filter.field}`;

  // support both flat and grouped options
  const options = filter.options.length > 0 ? [...filter.options] // spreading fixes readonly issue
  : filter.optionGroups.map(optionGroup => ({
    text: optionGroup.subheading,
    options: optionGroup.options
  }));
  const getValue = () => {
    var _params$get;
    if (multi) return params.getList(filter.field);
    return (_params$get = params.get(filter.field)) !== null && _params$get !== void 0 ? _params$get : filter.defaultValue;
  };
  const handleChange = e => {
    if (multi) {
      params.setList(filter.field, e.target.value);
    } else {
      params.set(filter.field, e.target.value, {
        defaultValue: filter.defaultValue
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [filter.label && /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: id,
      marginBlockStart: "200",
      children: filter.label
    }), /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Select, {
        clearable: !filter.defaultValue,
        id: id,
        menuRenderer: virtualized ? virtualizedMenuRenderer : undefined,
        multi: multi,
        onChange: handleChange,
        options: options,
        placeholder: filter.placeholder,
        value: getValue()
        // TODO: remove this hack after talking with Trellis team
      }, multi ? undefined : getValue())
    })]
  });
}